import { useMutation } from '@tanstack/react-query';
import { forgotPassword } from '@uplift/api';

export const useForgotPasswordMutation = () => {
  return useMutation({
    mutationFn: async (args: { email: string }) => {
      await forgotPassword(args.email);
    }
  });
};
